export declare namespace AppCardTokenSections {
	interface Header {
		background: string;
		paddingX: string;
		paddingY: string;
	}

	interface Body {
		paddingX: string;
		paddingTop: string;
		paddingBottom: string;
	}

	interface Name {
		color: string;
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
	}

	interface Meta {
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
	}

	interface Subtitle {
		color: string;
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
		marginTop: string;
	}

	interface ItemCount {
		color: string;
		fontWeight: string;
		fontSize: string;
		lineHeight: string;
	}
}

export type AppCardTokens = {
	header: AppCardTokenSections.Header;
	body: AppCardTokenSections.Body;
	name: AppCardTokenSections.Name;
	meta: AppCardTokenSections.Meta;
	subtitle: AppCardTokenSections.Subtitle;
	itemCount: AppCardTokenSections.ItemCount;
};

export const header: AppCardTokenSections.Header = {
	background: '{surface.50}',
	paddingX: '1rem',
	paddingY: '0.5rem',
};

export const body: AppCardTokenSections.Body = {
	paddingX: '1rem',
	paddingTop: '0.5rem',
	paddingBottom: '0.75rem',
};

export const name: AppCardTokenSections.Name = {
	color: '{surface.800}',
	fontWeight: '600',
	fontSize: '1rem',
	lineHeight: '1.25rem',
};

export const meta: AppCardTokenSections.Meta = {
	fontWeight: '400',
	fontSize: '0.875rem',
	lineHeight: '1.25rem',
};

export const subtitle: AppCardTokenSections.Subtitle = {
	color: '{surface.400}',
	fontWeight: '500',
	fontSize: '0.875rem',
	lineHeight: '1.25rem',
	marginTop: '0.125rem',
};

export const itemCount: AppCardTokenSections.ItemCount = {
	color: '{primary.400}',
	fontWeight: '600',
	fontSize: '1rem',
	lineHeight: '1.25rem',
};

export default {
	header,
	body,
	name,
	meta,
	subtitle,
	itemCount,
} satisfies AppCardTokens;
